module.exports = __webpack_public_path__ + "static/img/water2.899fb418.webp";